import { HttpResponse } from 'msw'
import { restHandlerFactory } from 'src/tests/mocks/handlerFactory'

export const sendTestEmailHandler = restHandlerFactory(
  '/trials/{trial_uid}/test_message_by_email',
  'post',
  () => {
    return HttpResponse.json(undefined, { status: 204 })
  },
)
